module.exports = __webpack_public_path__ + "static/media/sophie-avatar.1e9179a3.png";